import { dispatcher, api } from '@unicus/react-ui-kit';

export const CHECKINGACCOUNT = 'CHECKINGACCOUNT';
export const CHECKINGACCOUNT_REFRESH_RESOURCE =
  'CHECKINGACCOUNT_REFRESH_RESOURCE';
export const CHECKINGACCOUNT_FETCH_BALANCES = 'CHECKINGACCOUNT_FETCH_BALANCES';
export const CHECKINGACCOUNT_FETCH_BALANCES_FINISHED =
  'CHECKINGACCOUNT_FETCH_BALANCES_FINISHED';

export const CHECKINGACCOUNT_FETCH_INCOME_STATEMENT =
  'CHECKINGACCOUNT_FETCH_INCOME_STATEMENT';
export const CHECKINGACCOUNT_FETCH_INCOME_STATEMENT_FINISHED =
  'CHECKINGACCOUNT_FETCH_INCOME_STATEMENT_FINISHED';

export const refreshResource = () => (dispatch) => {
  dispatch(
    dispatcher.createAction(
      CHECKINGACCOUNT_REFRESH_RESOURCE,
      'checking-accounts'
    )
  );
};

export const fetch = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'checking-accounts',
    actionType: CHECKINGACCOUNT_FETCH_BALANCES,
    effect: async () => api.fetch('checking-accounts/balances', params)
  });
};

export const fetchIncomeStatement = (params) => async (dispatch) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'checking-accounts',
    actionType: CHECKINGACCOUNT_FETCH_INCOME_STATEMENT,
    effect: async () => api.fetch('checking-accounts/income-statement', params)
  });
};
